import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import styles from "./NotFound.module.css";

export default function NotFound() {
  return (
    <div className={styles.page}>
      <Nav theme="light" />

      <div className={styles.container}>
        <div className={styles.content}>
          <p className={styles.code}>// NOT FOUND</p>

          <h1 className={styles.title}>Nothing to see here.</h1>

          <p className={styles.subtitle}>
            This is not the page you're looking for.
          </p>

          <div className={styles.card}>
            <p className={styles.cardTitle}>Debug info</p>
            <ul className={styles.list}>
              <li>status: 404</li>
              <li>route: nowhere</li>
              <li>page: not found</li>
              <li>reason: that's all we know</li>
            </ul>
          </div>

          <div className={styles.actions}>
            <Link to="/" className={styles.primaryBtn}>
              return home →
            </Link>
          </div>

          <p className={styles.footerNote}>
            If this feels like a bug, it probably is.
          </p>
        </div>
      </div>

      <div className={styles.footerWrap}>
        <Footer theme="light" />
      </div>
    </div>
  );
}
